import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import { BorderGradientBox } from '@flipster/react/design-utils/border-gradient-box';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import UserIcon from '@flipster/react/icon/generated/UserIcon';
import { css } from '@flipster/styled-system/css';
import { center, hstack, stack, vstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

const tradingFeePercent = 25;
const validFor = 365;

export const RewardCardTradingFee = () => {
  return (
    <article
      className={stack({
        bgColor: 'background.default.level-1',
        color: 'content.default.level-5',
        w: '100%',
        p: { base: 16, smallDesktop: 24 },
        rounded: 8,
        gap: 16,
      })}
    >
      {/* header */}
      <div className={stack({ gap: 12, alignItems: 'flex-start' })}>
        <Badge type='tint' color='promotion'>
          <FormattedMessage id='Autogen_common.r251126.s_Reward' />
        </Badge>
        <div className={stack({ gap: 4 })}>
          <h3 className={css({ textStyle: 'Title/XS', color: 'inverse.white' })}>
            <FormattedMessage
              id='Autogen_common.r251126.s_Earn_tradingFeePercent_of_your_referee_s_trading_fees'
              values={{
                tradingFeePercent: tradingFeePercent,
              }}
            />
          </h3>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Get_paid_in_USDT_whenever_your_referee_trades_on_Flipster' />
          </p>
        </div>
      </div>
      <div className={vstack({ w: '100%', gap: 20, alignItems: 'stretch' })}>
        {/* avatar */}
        <div
          className={hstack({
            textStyle: 'Text/M/Regular',
            textAlign: 'center',
            gap: { base: 4, smallDesktop: 32 },
            color: 'content.default.level-5',
            alignItems: 'stretch',
          })}
        >
          <div className={css(avatarBoxStyles, { bgColor: 'background.default.level-0' })}>
            <p
              className={css({
                textStyle: 'Text/S/Strong',
                px: 10,
                py: 4,
                rounded: 30,
                bgColor: 'background.default.level-3',
              })}
            >
              <FormattedMessage id='Autogen_common.r251126.s_Referee' />
            </p>
            <UserIcon size={40} color={token('colors.content.default.level-1')} className={css({ mt: 20, mb: 16 })} />
            <p>
              <FormattedMessage id='Autogen_common.r251126.s_Make_any_trades_on_Flipster' />
            </p>
          </div>
          <div className={center()}>
            <ChevronRightIcon size={20} color={token('colors.content.default.level-1')} />
          </div>
          <BorderGradientBox
            bgColor='colors.background.default.level-0'
            gradientColor='gradients.programs.promotion'
            css={avatarBoxStyles}
          >
            <p
              className={css({
                textStyle: 'Text/S/Strong',
                px: 10,
                py: 4,
                rounded: 30,
                bgColor: 'background.accent.promotion.tint',
                color: 'inverse.white',
              })}
            >
              <FormattedMessage id='Autogen_common.r251126.s_Referrer' />
            </p>
            <UserIcon size={40} color={token('colors.content.accent.promotion')} className={css({ mt: 20, mb: 16 })} />
            <p>
              <FormattedMessage
                id='Autogen_common.r251126.s_Receive_tradingFeePercent_of_the_trading_fees_your_referee_generates'
                values={{
                  tradingFeePercent: tradingFeePercent,
                }}
              />
            </p>
          </BorderGradientBox>
        </div>
        {/* description */}
        <ul className={css({ list: 'disc', textStyle: 'Text/M/Regular', '& li:not(:first-child)': { mt: 8 } })}>
          <li>
            <FormattedMessage id='Autogen_common.r251126.s_Reward_is_paid_in_USDT' />
          </li>
          <li>
            <FormattedMessage
              id='Autogen_common.r251126.s_Valid_for_validFor_days_after_referee_s_sign_up'
              values={{
                validFor: validFor,
              }}
            />
          </li>
        </ul>
      </div>
    </article>
  );
};

const avatarBoxStyles = vstack.raw({
  flex: 1,
  px: 12,
  py: 16,
  rounded: 16,
});
